/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  MaterialReactTable,
  MRT_Cell,
  useMaterialReactTable,
  type MRT_ColumnDef,
  type MRT_TableOptions,
} from 'material-react-table';
import {
  Pagination,
  Typography,
  TextField,
  Button,
  Box,
  InputAdornment,
  useMediaQuery,
  PaginationItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Tabs,
  Tab,
  useTheme,
  Menu,
  MenuItem,
  Skeleton,
} from '@mui/material';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg';
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg';
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg';
import download from 'packages/novous_web/src/assets/icons/download.svg';
import PlusWhiteStroke from 'packages/novous_web/src/assets/icons/PlusWhiteStroke.svg';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import bulkUpload from 'packages/novous_web/src/assets/icons/bulkUpload.svg';
import eye from 'packages/novous_web/src/assets/icons/Eye.svg';
import edit from 'packages/novous_web/src/assets/icons/edit.svg';
import deleteIcon from 'packages/novous_web/src/assets/icons/Delete.svg';
import Devices from 'packages/novous_web/src/assets/icons/Devices.svg';
import dayjs from 'dayjs';
import DownloadData from 'packages/novous_web/src/common/components/DownloadData';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import { useToast } from 'packages/novous_web/src/context/ToastContext';
// import CustomiseDeviceTableModal from './CustomiseDeviceTableModal';
import BulkUploadModal from 'packages/novous_web/src/common/components/BulkUpload';
import { dayCount } from 'packages/novous_web/src/utils/helper';
import FilterDataModel from 'packages/novous_web/src/common/components/FilterDataModal';
import FilterDeviceModal from './FilterDeviceModal';
import { PageLoader } from 'packages/novous_web/src/common/components';
import { useLocation } from 'react-router-dom';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import menu from 'packages/novous_web/src/assets/icons/menu.svg';
// import turnOnIcon from 'packages/novous_web/src/assets/images/red stop.png';
// import turnOffIcon from 'packages/novous_web/src/assets/images/green start.png';
import useApiError from 'packages/novous_web/src/api/useApiError';
import { SdCard } from '@mui/icons-material';
import { all } from 'axios';
import InputField from 'packages/novous_web/src/common/components/InputField';

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};
interface Device {
  deviceId: string;
  vehicleRegistrationNo: string;
  version: string;
  totalUsedMb: string;
  deviceName: string;
  deviceType: string;
  updatedTime: string;
  lastAlarmDataTime: string;
  gpsStatus: number;
  sdCardStatus: number;
  dmsCameraStatus: number;
  fcwCameraStatus: number;
  powerTamperingStatus: number;
  createdAt: string;
  expirationDate: string;
  dataSource: string;
  groupName: string;
}

const initialColumnObj = {
  deviceId: { name: 'Device ID', status: true },
  vehicleRegistrationNo: { name: 'Vehicle Reg No.', status: true },
  version: { name: 'Version', status: true },
  totalUsedMb: { name: 'Used Data (in MB)', status: true },
  deviceName: { name: 'Device Name', status: true },
  deviceType: { name: 'Device Type', status: true },
  updatedTime: { name: 'Last Updated Time', status: true },
  groupName: { name: 'Depot Name', status: true },
  lastAlarmDataTime: { name: 'Last Update Aging (Day)', status: true },
  gpsStatus: { name: 'GPS Status', status: true },
  sdCardStatus: { name: 'SD Card Status', status: true },
  dmsCameraStatus: { name: 'DMS Camera Status', status: true },
  fcwCameraStatus: { name: 'FCW Camera Status', status: true },
  powerTamperingStatus: { name: 'Power Tampering Status', status: true },
  createdAt: { name: 'Installed Date', status: true },
  expirationDate: { name: 'Expiration Date', status: true },
  actions: { name: 'Actions', status: true },
};
interface DataTableProps {
  handleTile: (data: ColumnObjType) => void;
  selectedGroup?: string | null;
  onAllDeviceDataFetch?: (data: any) => void;
  selectedUser?: any;
  selectedCompany?: any;
}

const DeviceDataTable: React.FC<DataTableProps> = ({
  handleTile,
  selectedGroup,
  onAllDeviceDataFetch,
  selectedUser,
  selectedCompany,
}) => {
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<'error' | 'success' | 'warning' | 'info'>('error');
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  // Note: Wake-up status is now tracked using predefined fields:
  // "isDeviceWakeupTriggered": false,
  // "deviceWakeupTriggered": false,

  const [searchQuery, setSearchQuery] = useState('');
  const [data, setData] = useState<Device[]>([]);
  const [filteredData, setFilteredData] = useState<Device[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedDevice, setSelectedDevice] = useState<any>(null);
  const isSmallScreen = useMediaQuery('(max-width:850px)');
  const [currentPage, setCurrentPage] = useState(1);
  const [pagesData, setPagesData] = useState<Device[][]>([]);
  const paginatedArr = useRef<any[]>([null]);
  const [paginationKeys, setPaginationKeys] = useState<{ [key: number]: string | null }>({ 1: null });
  const pageSize = 10;
  const { user } = useAuth();
  const navigate = useNavigate();
  const debouncedSearchQuery = useDebounce(searchQuery, 200);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState<string>('pdf');
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // State for delete modal
  const [deleteingDevice, setDeletingDevice] = useState<{
    groupName?: string;
    deviceId?: string;
    vehicleRegistrationNo?: string;
  } | null>(null);
  const [deleteReason, setDeleteReason] = useState('');
  const { showToast } = useToast();

  const theme = useTheme();
  const [isCustomiseModalOpen, setIsCustomiseModalOpen] = useState(false);
  const [columnObj, setColumnObj] = useState<ColumnObjType>(initialColumnObj);
  const [isUploadModelOpen, setIsUploadModelOpen] = useState(false);
  const [driverDoc, setDriverDoc] = useState<any>();
  const [isFilterModel, setIsFilterModelOpen] = useState(false);
  const [wakeupSendingDeviceIds, setWakeupSendingDeviceIds] = useState<string[]>([]);
  const handleFilterClose = () => setIsFilterModelOpen(false);
  const handleFilterOpen = () => setIsFilterModelOpen(true);
  const location = useLocation();
  // true only when navigating from dashboard arrow click; false on direct load or refresh
  const cameFromDashboard = useRef(location.state?.activeTab === 1);
  const [activeTab, setActiveTab] = useState(0);
  const [tilesObj, setTilesObj] = useState<ColumnObjType>({
    Stat1: { name: 'Total Devices', status: true },
  });

  const [filterData, setFilterData] = useState<{
    group?: string | null;
    device?: string | null;
    vehicle?: string | null;
  } | null>(() => {
    // Only accept device-page filter shape { group, device, vehicle }; ignore dashboard's { data, isfiltered }
    const s = location.state?.filterData;
    if (s && ('group' in s || 'device' in s || 'vehicle' in s)) return s;
    return null;
  });

  // Clear location state after consuming so browser refresh doesn't restore stale tab/filter state
  useEffect(() => {
    if (location.state) {
      window.history.replaceState(null, '');
    }
  }, []);

  const [allDevicesList, setAllDevicesList] = useState<Device[]>([]);
  const [faultyDevicesList, setFaultyDevicesList] = useState<Device[]>([]);

  const {
    data: downloadDeviceData,
    error: downloadDeviceError,
    loading: downloadDeviceLoading,
    fetchData: fetchDownloadDeviceData,
  } = useApiError<any>(`${API_ENDPOINTS.directories.DEVICE_DOWNLOAD}`, 'POST', 'blob');

  const {
    data: downloadDeviceSuperAdminData,
    error: downloadDeviceSuperAdminError,
    loading: downloadDeviceSuperAdminLoading,
    fetchData: fetchDownloadDeviceSuperAdminData,
  } = useApiError<any>(`${API_ENDPOINTS.directories.DOWNLOAD_DEVICES_SUPERADMIN}`, 'POST', 'blob');

  const {
    data: allDeviceData,
    error: allDeviceError,
    loading: allDeviceLoading,
    fetchData: fetchAllDeviceData,
  } = useAxios<any>(`${API_ENDPOINTS.directories.GET_ALL_DEVICES}`, 'POST');

  const {
    data: allDeviceSuperAdminData,
    error: allDeviceSuperAdminError,
    loading: allDeviceSuperAdminLoading,
    fetchData: fetchAllDeviceSuperAdminData,
  } = useAxios<any>(`${API_ENDPOINTS.directories.GET_ALL_DEVICES_SUPERADMIN}`, 'POST');

  const {
    data: deviceData,
    error: deviceError,
    loading: deviceLoading,
    fetchData: fetchDeviceData,
  } = useAxios<any>(`${API_ENDPOINTS.directories.GET_ALL_DEVICE_PAGINATION}`, 'POST');

  const {
    data: deviceSuperAdminData,
    error: deviceSuperAdminError,
    loading: deviceSuperAdminLoading,
    fetchData: fetchDeviceSuperAdminData,
  } = useAxios<any>(`${API_ENDPOINTS.directories.GET_ALL_DEVICES_SUPERADMIN_PAGINATION}`, 'POST');

  const {
    data: deviceDeleteData,
    error: deviceDeleteError,
    loading: deviceDeleteLoading,
    fetchData: deleteDevice,
  } = useAxios<any>(`${API_ENDPOINTS.directories.DEVICE_DELETE}`, 'POST');

  const {
    data: wakeupDeviceData,
    error: wakeupDeviceError,
    loading: wakeupDeviceLoading,
    fetchData: fetchWakeupDeviceData,
  } = useAxios<any>(`${API_ENDPOINTS.utility.WAKEUP_DEVICE}`, 'POST');

  const {
    data: sleepDeviceData,
    error: sleepDeviceError,
    loading: sleepDeviceLoading,
    fetchData: fetchSleepDeviceData,
  } = useAxios<any>(`${API_ENDPOINTS.utility.SLEEP_DEVICE}`, 'POST');

  // Helper function to determine if user is super admin
  const isSuperAdmin = user?.authorities?.includes('ROLE_SUPER_ADMIN');

  // Helper function to get fleetId based on user role
  const getFleetId = () => {
    if (isSuperAdmin && selectedUser?.customer_id) {
      return selectedUser.customer_id;
    }
    return user?.customer_id;
  };

  // Unified fetch wrapper that routes to correct endpoint based on user role
  const callFetchDeviceData = (params: any) => {
    const fleetId = getFleetId();
    const payloadWithFleetId = { ...params, fleetId };

    if (isSuperAdmin) {
      fetchDeviceSuperAdminData(payloadWithFleetId);
    } else {
      fetchDeviceData(payloadWithFleetId);
    }
  };

  const callFetchAllDeviceData = (params: any) => {
    const fleetId = getFleetId();
    const payloadWithFleetId = { ...params, fleetId };

    if (isSuperAdmin) {
      fetchAllDeviceSuperAdminData(payloadWithFleetId);
    } else {
      fetchAllDeviceData(payloadWithFleetId);
    }
  };

  // Fetch full device list for tiles regardless of active tab.
  useEffect(() => {
    const fleetId = getFleetId();
    if (!fleetId) return;

    callFetchAllDeviceData({
      fleetId,
    });
  }, [user?.customer_id, selectedUser?.customer_id, isSuperAdmin]);

  // Process allDeviceData when it arrives
  useEffect(() => {
    const relevantAllData = isSuperAdmin ? allDeviceSuperAdminData : allDeviceData;
    if (relevantAllData?.data && Array.isArray(relevantAllData.data)) {
      const getDeviceNameFromDataSource = (dataSource: string): string => {
        if (dataSource === 'vp2') {
          return 'Novus Safe Lite';
        } else if (dataSource === 'android') {
          return 'Novus Safe Pro';
        }
        return 'N/A';
      };

      const processedDevices: Device[] = relevantAllData.data.map((device: any) => ({
        deviceId: device.deviceId,
        vehicleRegistrationNo: device.vehicleRegistrationNo,
        version: device.version || 'N/A',
        totalUsedMb: device.totalUsedMb || 'N/A',
        deviceName: getDeviceNameFromDataSource(device.dataSource),
        deviceType: device.deviceType || 'N/A',
        updatedTime: device.updatedTime || 'N/A',
        lastAlarmDataTime: device.lastAlarmDataTime || 'N/A',
        gpsStatus: device.gpsStatus || 0,
        sdCardStatus: device.sdCardStatus || 0,
        dmsCameraStatus: device.dmsCameraStatus || 0,
        fcwCameraStatus: device.fcwCameraStatus || 0,
        powerTamperingStatus: device.powerTamperingStatus || 0,
        createdAt: device.createdAt || 'N/A',
        expirationDate: device.expirationDate,
        dataSource: device.dataSource,
        ...device,
      }));

      setAllDevicesList(processedDevices);

      const faulty = processedDevices.filter((device: any) =>
        cameFromDashboard.current
          ? device.errorStatus === 1 && device.powerTamperingStatus === 1
          : device.errorStatus === 1,
      );
      setFaultyDevicesList(faulty);

      // Call the callback to pass allDeviceData to parent
      if (onAllDeviceDataFetch) {
        onAllDeviceDataFetch(relevantAllData);
      }
    }
  }, [allDeviceData, onAllDeviceDataFetch, allDeviceSuperAdminData, isSuperAdmin]);

  useEffect(() => {
    if (location?.state?.activeTab !== undefined) {
      setActiveTab(location.state.activeTab);
    }
  }, [location?.state?.activeTab]);

  useEffect(() => {
    if (activeTab === 1) {
      // For Faulty Devices tab - use the filtered faulty devices with client-side pagination
      const faultyWithoutSearch =
        debouncedSearchQuery === ''
          ? faultyDevicesList
          : faultyDevicesList.filter(
              (item) =>
                item.deviceId?.toLowerCase().includes(debouncedSearchQuery.toLowerCase()) ||
                item.vehicleRegistrationNo?.toLowerCase().includes(debouncedSearchQuery.toLowerCase()) ||
                (item.deviceName &&
                  item.deviceName.toLowerCase().includes(debouncedSearchQuery.toLowerCase())) ||
                item.deviceType?.toLowerCase().includes(debouncedSearchQuery.toLowerCase()),
            );
      setFilteredData(faultyWithoutSearch);
      setCurrentPage(1);
    }
  }, [activeTab, faultyDevicesList, debouncedSearchQuery]);

  useEffect(() => {
    if (deviceDeleteError || deviceError || downloadDeviceError || downloadDeviceSuperAdminError) {
      showToast(deviceDeleteError || deviceError || downloadDeviceError || downloadDeviceSuperAdminError || 'Something went wrong!', 'error');
    }
  }, [deviceDeleteError, deviceError, downloadDeviceError, downloadDeviceSuperAdminError]);

  useEffect(() => {
    if (wakeupDeviceData?.status === 200) {
      showToast(wakeupDeviceData?.message, 'success');
      if (selectedDevice?.vehicleRegistrationNo) {
        const doneId = selectedDevice.vehicleRegistrationNo;
        setWakeupSendingDeviceIds((prev) => prev.filter((id) => id !== doneId));
      }
      setAnchorEl(null);
      if (selectedDevice) {
        callFetchDeviceData({
          lastEvaluatedKey: null,
          vehicleGroup: selectedGroup && selectedGroup,
        });
      }
    } else if (wakeupDeviceError) {
      showToast('Error occurred while sending wake-up command to device.', 'error');
      if (selectedDevice?.vehicleRegistrationNo) {
        const errorId = selectedDevice.vehicleRegistrationNo;
        setWakeupSendingDeviceIds((prev) => prev.filter((id) => id !== errorId));
      }
      setAnchorEl(null);
    }
  }, [wakeupDeviceData, wakeupDeviceError]);

  useEffect(() => {
    if (sleepDeviceData?.status === 200) {
      showToast(sleepDeviceData?.message, 'success');
      if (selectedDevice) {
        callFetchDeviceData({
          lastEvaluatedKey: null,
          vehicleGroup: selectedGroup && selectedGroup,
        });
      }
    } else if (sleepDeviceError) {
      showToast('Error occurred while sending sleep command to device.', 'error');
    }
  }, [sleepDeviceData, sleepDeviceError]);

  // Filter Handler
  const handleFilterSave = (filters: any) => {
    setCurrentPage(1);
    setPaginationKeys({ 1: null }); // Reset pagination keys when filters change

    if (filters.group || filters.device || selectedGroup || filters.vehicle) {
      setFilterData(
        selectedGroup ? { group: selectedGroup, device: filters.device, vehicle: filters.vehicle } : filters,
      );

      // Prepare fetchDeviceData parameters
      const fetchParams: any = {
        lastEvaluatedKey: null,
      };

      // If device is selected, add vehicleId
      if (filters.device) {
        fetchParams.vehicleId = filters.device;
      }

      // If group is selected, add vehicleGroup
      if (filters.group || selectedGroup) {
        fetchParams.vehicleGroup = filters.group || selectedGroup;
      }

      // If vehicle is selected, add vehicleId
      if (filters.vehicle) {
        fetchParams.vehicleId = filters.vehicle;
      }

      // Call fetchDeviceData with the parameters
      const fleetId = getFleetId();
      if (fleetId) {
        callFetchDeviceData(fetchParams);
      }
    } else {
      setFilterData(null);
      // Reset to default fetch when no filters
      const fleetId = getFleetId();
      if (fleetId) {
        callFetchDeviceData({
          lastEvaluatedKey: null,
          vehicleGroup: selectedGroup && selectedGroup,
        });
      }
    }
  };

  useEffect(() => {
    if (activeTab === 0) {
      // For All Devices tab - apply filters from pagination endpoint
      if (filterData) {
        const applyFilters = (dataList: any[], filters: any) => {
          return dataList.filter(
            (item) =>
              (filters.group ? item.groupName === filters.group : true) &&
              (filters.device ? item.deviceType === filters.device : true),
          );
        };
        const filteredResults = applyFilters(data, filterData);
        setFilteredData(filteredResults);
      } else {
        setFilteredData(data);
      }
    } else if (activeTab === 1) {
      // For Faulty Devices tab - apply filters to faulty devices
      if (filterData) {
        const applyFilters = (dataList: any[], filters: any) => {
          return dataList.filter(
            (item) =>
              (filters.group ? item.groupName === filters.group : true) &&
              (filters.device ? item.deviceType === filters.device : true),
          );
        };
        const filteredResults = applyFilters(faultyDevicesList, filterData);
        setFilteredData(filteredResults);
      } else {
        setFilteredData(faultyDevicesList);
      }
    }
  }, [filterData, data, faultyDevicesList, activeTab]);

  const handleReset = () => {
    setTilesObj({
      // Stat1: { name: "Total Ignition Trips", status: true },
      Stat1: { name: 'Total Devices', status: true },
      Stat2: { name: 'Active devices', status: true },
      Stat3: { name: 'Faulty Devices', status: true },
      Stat4: { name: 'Under maintenance', status: true },
    });
  };

  // Update tiles based on active tab
  useEffect(() => {
    if (activeTab === 1) {
      // Show Faulty Devices count only on Faulty Devices tab
      setTilesObj({
        Stat1: { name: 'Total Devices', status: true },
        Stat2: { name: 'Faulty Devices', status: true },
      });
    } else {
      // Show only Total Devices on All Devices tab
      setTilesObj({
        Stat1: { name: 'Total Devices', status: true },
      });
    }
  }, [activeTab]);

  useEffect(() => {
    handleTile(tilesObj);
  }, [tilesObj]);

  // Download handler

  useEffect(() => {
    if (downloadDeviceData) {
      try {
        if (downloadDeviceData instanceof Blob) {
          const url = window.URL.createObjectURL(downloadDeviceData);
          const a = document.createElement('a');
          a.href = url;
          let extension = selectedFormat.toLowerCase();
          if (extension === 'excel') {
            extension = 'xlsx'; // Use xlsx for Excel format
          }

          const fileName = `device_data.${extension}`;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        } else {
          console.error('Invalid response format. Expected a Blob.');
        }
      } catch (error) {
        console.error('Error downloading file:', error);
      } finally {
        setIsDownloadModalOpen(false);
      }
    }
  }, [downloadDeviceData]);

  useEffect(() => {
    if (downloadDeviceSuperAdminData) {
      try {
        if (downloadDeviceSuperAdminData instanceof Blob) {
          const url = window.URL.createObjectURL(downloadDeviceSuperAdminData);
          const a = document.createElement('a');
          a.href = url;
          let extension = selectedFormat.toLowerCase();
          if (extension === 'excel') {
            extension = 'xlsx'; // Use xlsx for Excel format
          }

          const fileName = `device_data.${extension}`;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        } else {
          console.error('Invalid response format. Expected a Blob.');
        }
      } catch (error) {
        console.error('Error downloading file:', error);
      } finally {
        setIsDownloadModalOpen(false);
      }
    }
  }, [downloadDeviceSuperAdminData]);

  const handleDownloadModalClose = () => {
    setIsDownloadModalOpen(false);
  };
  const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFormat(event.target.value);
  };
  // const handleDownload = async () => {
  //     fetchDownloadDeviceData({ fleetId: user?.customer_id, fileType: selectedFormat });
  // };

  const handleDownload = async () => {
    setIsSendingEmail(true);
    const requestData = {
      fleetId: getFleetId(),
      fileType: selectedFormat,
      ...(activeTab === 1 && { isFaultDevice: 1 }),
    };

    try {
      const response = await (isSuperAdmin ? fetchDownloadDeviceSuperAdminData : fetchDownloadDeviceData)(requestData);
      if (
        response?.type === 'text/csv' ||
        response?.type === 'application/pdf' ||
        response?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        setAlertMessage(`File has been downloaded successfully`);
        setAlertType('success');
        setAlertOpen(true);
      } else {
        setAlertMessage(response?.error);
        setAlertType('error');
        setAlertOpen(true);
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setAlertMessage((error as Error).message);
      setAlertType('error');
      setAlertOpen(true);
    } finally {
      setIsSendingEmail(false);
    }
  };

  const handleViewDetails = () => {
    console.info('View IconButton clicked', selectedDevice);
    if (selectedDevice) {
      navigate('details', { state: selectedDevice });
    } else {
      console.error('selectedDevice data is undefined');
    }
  };

  const handleEditClick = () => {
    console.info('Edit IconButton clicked');
    if (selectedDevice) {
      navigate(`./edit/${selectedDevice.deviceId}`);
    } else {
      console.error('selectedDevice data is undefined');
    }
  };

  const handleWakeupDevice = async () => {
    if (selectedDevice && !isWakeUpDeviceEnabled(selectedDevice)) {
      const currentVehicleId = selectedDevice.vehicleRegistrationNo;
      const payload = {
        vehicleId: currentVehicleId,
        fleetId: user?.customer_id,
      };
      setWakeupSendingDeviceIds((prev) =>
        prev.includes(currentVehicleId) ? prev : [...prev, currentVehicleId],
      );
      try {
        await fetchWakeupDeviceData(payload);
      } catch (e) {
        // Toast handled in effect
      } finally {
        setWakeupSendingDeviceIds((prev) => prev.filter((id) => id !== currentVehicleId));
        setAnchorEl(null);
      }
    }
  };

  const handleSleepDevice = () => {
    if (selectedDevice && isWakeUpDeviceEnabled(selectedDevice)) {
      const payload = {
        vehicleId: selectedDevice.vehicleRegistrationNo,
        fleetId: user?.customer_id,
      };
      fetchSleepDeviceData(payload);
      setAnchorEl(null);
    }
  };
  // Check if wake-up was triggered for this device using predefined fields
  const isWakeUpDeviceEnabled = (device: any) => {
    if (!device) return false;
    // Check either of the predefined boolean fields
    return device.isDeviceWakeupTriggered === true || device.deviceWakeupTriggered === true;
  };

  const handleDeleteClickHandler = () => {
    console.info('Delete IconButton clicked');
    if (selectedDevice) {
      handleDeleteClick(selectedDevice);
    } else {
      console.error('selectedDevice data is undefined');
    }
  };

  // Customise handler
  const handleOpen = () => setIsCustomiseModalOpen(true);
  const viewMenuData = [
    { name: 'View Details', icon: eye, click: handleViewDetails },
    // { name: 'Edit Device', icon: edit, click: handleEditClick },
    // {name : 'Delete Device', icon: deleteIcon, click: handleDeleteClickHandler},
    // Show Wake-up and Sleep Device buttons only when dataSource === 'android'
    ...(selectedDevice?.dataSource === 'android'
      ? [
          {
            name:
              selectedDevice && wakeupSendingDeviceIds.includes(selectedDevice.vehicleRegistrationNo)
                ? 'Sending Command...'
                : 'Wake-up Device',
            icon: require('packages/novous_web/src/assets/images/green start.png'),
            click: handleWakeupDevice,
            disabled:
              (selectedDevice && wakeupSendingDeviceIds.includes(selectedDevice.vehicleRegistrationNo)) ||
              isWakeUpDeviceEnabled(selectedDevice),
          },
          {
            name: 'Sleep Device',
            icon: require('packages/novous_web/src/assets/images/red stop.png'),
            click: handleSleepDevice,
            disabled: !isWakeUpDeviceEnabled(selectedDevice),
          },
        ]
      : []),
    // { name: 'Delete Vehicle', icon: deleteIcon, click: handleDeleteClickHandler, disabled: false },
  ];

  // Bulk Upload handler
  const handleUploadModalClose = () => {
    setIsUploadModelOpen(false);
    callFetchDeviceData({
      lastEvaluatedKey: null,
      vehicleGroup: selectedGroup && selectedGroup,
    });
  };

  // Delete handler
  const DeleteDevice = async () => {
    if (!deleteingDevice) return;
    const payload = {
      device: deleteingDevice,
      reason: deleteReason,
    };
    const response = await deleteDevice(payload);
    if (response?.status === 200) {
      showToast(response.message, 'success');
    } else {
      showToast(response?.error || 'Failed to delete device', 'error');
    }
  };

  useEffect(() => {
    if (deviceDeleteError) {
      showToast(deviceDeleteError, 'error');
    }
  }, [deviceDeleteError]);

  const handleDeleteClick = (device: any) => {
    setIsDeleteModalOpen(true); // Open delete confirmation modal
    setDeletingDevice(device);
    setDeleteReason(''); // Reset reason
  };
  const handleDeleteConfirm = () => {
    DeleteDevice();
    setIsDeleteModalOpen(false);
    setDeletingDevice(null);
    setDeleteReason('');
  };
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false); // Close modal without deleting
    setDeletingDevice(null);
    setDeleteReason('');
  };

  useEffect(() => {
    const fleetId = getFleetId();
    if (fleetId) {
      console.info('fetchDeviceData: useEffect');

      const fetchParams: any = {
        lastEvaluatedKey: null,
      };

      // If device is selected, add vehicleId
      if (filterData) {
        if (filterData.group) {
          fetchParams.vehicleGroup = filterData.group;
        }
        if (filterData.device) {
          fetchParams.vehicleId = filterData.device;
        }
        if (filterData.vehicle) {
          fetchParams.vehicleId = filterData.vehicle;
        }
      }

      callFetchDeviceData(fetchParams);
    }
  }, [user?.customer_id, selectedUser?.customer_id, isSuperAdmin, filterData]);

  useEffect(() => {
    const relevantData = isSuperAdmin ? deviceSuperAdminData : deviceData;
    if (relevantData?.data?.fcwIotDeviceEntityList) {
      const getDeviceNameFromDataSource = (dataSource: string): string => {
        if (dataSource === 'vp2') {
          return 'Novus Safe Lite';
        } else if (dataSource === 'android') {
          return 'Novus Safe Pro';
        }
        return 'N/A';
      };

      const deviceListData: Device[] = relevantData.data.fcwIotDeviceEntityList.map((device: any) => ({
        deviceId: device.deviceId,
        vehicleRegistrationNo: device.vehicleRegistrationNo,
        version: device.version || 'N/A',
        totalUsedMb: device.totalUsedMb || 'N/A',
        deviceName: getDeviceNameFromDataSource(device.dataSource),
        deviceType: device.deviceType || 'N/A',
        updatedTime: device.updatedTime || 'N/A',
        lastAlarmDataTime: device.lastAlarmDataTime || 'N/A',
        gpsStatus: device.gpsStatus || 0,
        sdCardStatus: device.sdCardStatus || 0,
        dmsCameraStatus: device.dmsCameraStatus || 0,
        fcwCameraStatus: device.fcwCameraStatus || 0,
        powerTamperingStatus: device.powerTamperingStatus || 0,
        createdAt: device.createdAt || 'N/A',
        expirationDate: device.expirationDate,
        dataSource: device.dataSource,
        ...device,
      }));
      setData(deviceListData);
    }
  }, [deviceData, deviceSuperAdminData, isSuperAdmin]);

  useEffect(() => {
    const relevantData = isSuperAdmin ? deviceSuperAdminData : deviceData;
    if (relevantData?.data?.lastEvaluatedKey) {
      const nextPage = currentPage + 1;
      const lastEvaluatedKeyStr = JSON.stringify(relevantData.data.lastEvaluatedKey);
      if (paginationKeys[nextPage] !== lastEvaluatedKeyStr) {
        setPaginationKeys((prev) => ({
          ...prev,
          [nextPage]: lastEvaluatedKeyStr,
        }));
      }
    }
  }, [deviceData, deviceSuperAdminData, currentPage, isSuperAdmin]);

  //  Search option
  useEffect(() => {
    const query = debouncedSearchQuery?.toLowerCase() || '';

    if (activeTab === 0) {
      // All Devices tab - search in paginated data
      if (query) {
        const filteredDataArr = data.filter(
          (item) =>
            item.deviceId?.toLowerCase().includes(query) ||
            item.vehicleRegistrationNo?.toLowerCase().includes(query) ||
            (item.deviceName && item.deviceName.toLowerCase().includes(query)) ||
            item.deviceType?.toLowerCase().includes(query),
        );
        setFilteredData(filteredDataArr);
      } else {
        setFilteredData(data);
      }
    } else if (activeTab === 1) {
      // Faulty Devices tab - search in faulty devices
      if (query) {
        const filteredDataArr = faultyDevicesList.filter(
          (item) =>
            item.deviceId?.toLowerCase().includes(query) ||
            item.vehicleRegistrationNo?.toLowerCase().includes(query) ||
            (item.deviceName && item.deviceName.toLowerCase().includes(query)) ||
            item.deviceType?.toLowerCase().includes(query),
        );
        setFilteredData(filteredDataArr);
      } else {
        setFilteredData(faultyDevicesList);
      }
    }
  }, [debouncedSearchQuery, data, faultyDevicesList, activeTab]);

  const handleTabChange = (event: any, newValue: number) => {
    setCurrentPage(1); // Reset to first page when changing tabs
    setActiveTab(newValue);

    // Manual tab click clears the dashboard-navigation context
    if (newValue === 1) {
      cameFromDashboard.current = false;
    }

    // When switching to All Devices tab, fetch paginated data
    if (newValue === 0) {
      const fetchParams: any = {};

      // If filters are applied, add them
      if (filterData) {
        if (filterData.group) {
          fetchParams.vehicleGroup = filterData.group;
        }
        if (filterData.device) {
          fetchParams.vehicleId = filterData.device;
        }
        if (filterData.vehicle) {
          fetchParams.vehicleId = filterData.vehicle;
        }
      } else {
        // If no filters, use selectedGroup
        if (selectedGroup) {
          fetchParams.vehicleGroup = selectedGroup;
        }
      }

      setPaginationKeys({ 1: null }); // Reset pagination keys
      callFetchDeviceData(fetchParams);
    }
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // Handler for changing pages.
  useEffect(() => {
    if (deviceData) {
      setPagesData((prev) => {
        const newPages = [...prev];
        newPages[currentPage - 1] = deviceData.data;
        return newPages;
      });
    }
  }, [deviceData, currentPage]);

  const paginatedData = useMemo(() => {
    // For faulty devices (filtered data), use client-side pagination
    // For all devices, use server-side pagination (display all loaded data)
    if (activeTab === 1) {
      // Faulty Devices tab: client-side pagination
      const start = (currentPage - 1) * pageSize;
      const end = start + pageSize;
      return filteredData.slice(start, end);
    } else {
      // All Devices tab: server-side pagination (show all current page data)
      return filteredData;
    }
  }, [filteredData, currentPage, activeTab]);

  // Removed duplicate useEffect - handled above

  const relevantDeviceData = isSuperAdmin ? deviceSuperAdminData : deviceData;
  const totalPages = relevantDeviceData?.data?.lastEvaluatedKey
    ? Object.keys(paginationKeys).length
    : currentPage;

  const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
    if (page === currentPage) return;
    setCurrentPage(page);

    // Only fetch new pages for "All Devices" tab (activeTab === 0)
    // For "Faulty Devices" tab, use client-side pagination
    if (activeTab === 0) {
      // Prepare fetchDeviceData parameters with filters
      const fetchParams: any = {};

      // If filters are applied, add them
      if (filterData) {
        if (filterData.group) {
          fetchParams.vehicleGroup = filterData.group;
        }
        if (filterData.device) {
          fetchParams.vehicleId = filterData.device;
        }
        if (filterData.vehicle) {
          fetchParams.vehicleId = filterData.vehicle;
        }
      } else {
        // If no filters, use selectedGroup
        if (selectedGroup) {
          fetchParams.vehicleGroup = selectedGroup;
        }
      }

      // Fetch next page data if not already loaded
      const keyForTargetPage = paginationKeys[page];
      if (page > 1 && keyForTargetPage) {
        fetchParams.lastEvaluatedKey = keyForTargetPage ? JSON.parse(keyForTargetPage) : null;
        callFetchDeviceData(fetchParams);
      } else if (page === 1) {
        // Reset to first page
        fetchParams.lastEvaluatedKey = null;
        callFetchDeviceData(fetchParams);
      }
    }
  };
  const formatDateTime = (dateTimeStr: string): string => {
    return dayjs(dateTimeStr).format('DD MMM, YYYY hh:mm A'); // Example: "11 Nov, 2024 05:03 PM"
  };

  // Table Option ---------------
  const allColumns: MRT_ColumnDef<Device>[] = useMemo(() => {
    return [
      {
        accessorKey: 'deviceId',
        header: 'Device ID',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '12px 16px', overflow: 'hidden' },
        },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'vehicleRegistrationNo',
        header: 'Vehicle Reg No.',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'version',
        header: 'Version',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '12px 16px', overflow: 'hidden' },
        },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>() || 'N/A'}
          </Typography>
        ),
      },
      {
        accessorKey: 'totalUsedMb',
        header: 'Used Data (in MB)',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '12px 16px', overflow: 'hidden' },
        },
        Cell: ({ cell, row }) => {
          const value = cell.getValue<number>();
          const dataSource = row.original.dataSource; // Access the dataSource field from the row
          return (
            <Typography variant="body2" fontWeight={400} noWrap>
              {value !== null && value !== undefined ? value.toFixed(2) : 'N/A'}
            </Typography>
          );
        },
      },
      {
        accessorKey: 'groupName',
        header: 'Depot Name',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'deviceName',
        header: 'Device Name',
        enableColumnActions: false,
        size: isSmallScreen ? 120 : 200,
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
          },
        },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>() || 'N/A'}
          </Typography>
        ),
      },
      {
        accessorKey: 'deviceType',
        header: 'Device Type',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'updatedTime',
        header: 'Last Updated Time',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>() && formatDateTime(cell.getValue<string>())}
          </Typography>
        ),
      },
      {
        accessorKey: 'lastAlarmDataTime',
        header: 'Last Update Aging (Day)',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 200,
        Cell: ({ row }) => {
          return (
            <Typography
              variant="body2"
              fontWeight={400}
              sx={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
              }}
            >
              {dayCount(row.original.updatedTime)}
            </Typography>
          );
        },
      },
      {
        accessorKey: 'gpsStatus',
        header: 'GPS Status',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 200,
        Cell: ({ cell }) => {
          const rawValue = cell.getValue() as number | string; // 👈 Explicit cast
          const status = Number(rawValue); // safely normalize to number if possible

          let backgroundColor: string;
          let color = '#219653'; // default green

          switch (status) {
            case 1:
              backgroundColor = '#FF0000';
              color = '#fff';
              break;
            case 0:
              backgroundColor = '#D9EDE6';
              break;
            default:
              backgroundColor = '#E0ECFD';
          }

          const displayText = status === 0 ? 'OK' : status === 1 ? 'NOT OK' : String(rawValue);

          return (
            <div
              style={{
                backgroundColor,
                padding: '4px 8px',
                borderRadius: '12px',
                display: 'inline-block',
                minWidth: '80px',
                textAlign: 'center',
                lineHeight: '18px',
                color,
              }}
            >
              {/* ✅ Ensure children is a string */}
              <Typography variant="body2" fontWeight={500}>
                {displayText}
              </Typography>
            </div>
          );
        },
      },
      {
        accessorKey: 'sdCardStatus',
        header: 'SD Card Status',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 200,
        Cell: ({ cell }) => {
          const rawValue = cell.getValue() as number | string; // 👈 Explicit cast
          const status = Number(rawValue); // safely normalize to number if possible

          let backgroundColor: string;
          let color = '#219653'; // default green

          switch (status) {
            case 1:
              backgroundColor = '#FF0000';
              color = '#fff';
              break;
            case 0:
              backgroundColor = '#D9EDE6';
              break;
            default:
              backgroundColor = '#E0ECFD';
          }

          const displayText = status === 0 ? 'OK' : status === 1 ? 'NOT OK' : String(rawValue);

          return (
            <div
              style={{
                backgroundColor,
                padding: '4px 8px',
                borderRadius: '12px',
                display: 'inline-block',
                minWidth: '80px',
                textAlign: 'center',
                lineHeight: '18px',
                color,
              }}
            >
              {/* ✅ Ensure children is a string */}
              <Typography variant="body2" fontWeight={500}>
                {displayText}
              </Typography>
            </div>
          );
        },
      },
      {
        accessorKey: 'dmsCameraStatus',
        header: 'DMS Camera Status',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 200,
        Cell: ({ cell }) => {
          const rawValue = cell.getValue() as number | string; // 👈 Explicit cast
          const status = Number(rawValue); // safely normalize to number if possible

          let backgroundColor: string;
          let color = '#219653'; // default green

          switch (status) {
            case 1:
              backgroundColor = '#FF0000';
              color = '#fff';
              break;
            case 0:
              backgroundColor = '#D9EDE6';
              break;
            default:
              backgroundColor = '#E0ECFD';
          }

          const displayText = status === 0 ? 'OK' : status === 1 ? 'NOT OK' : String(rawValue);

          return (
            <div
              style={{
                backgroundColor,
                padding: '4px 8px',
                borderRadius: '12px',
                display: 'inline-block',
                minWidth: '80px',
                textAlign: 'center',
                lineHeight: '18px',
                color,
              }}
            >
              {/* ✅ Ensure children is a string */}
              <Typography variant="body2" fontWeight={500}>
                {displayText}
              </Typography>
            </div>
          );
        },
      },
      {
        accessorKey: 'fcwCameraStatus',
        header: 'FCW Camera Status',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 200,
        Cell: ({ cell }) => {
          const rawValue = cell.getValue() as number | string; // 👈 Explicit cast
          const status = Number(rawValue); // safely normalize to number if possible

          let backgroundColor: string;
          let color = '#219653'; // default green

          switch (status) {
            case 1:
              backgroundColor = '#FF0000';
              color = '#fff';
              break;
            case 0:
              backgroundColor = '#D9EDE6';
              break;
            default:
              backgroundColor = '#E0ECFD';
          }

          const displayText = status === 0 ? 'OK' : status === 1 ? 'NOT OK' : String(rawValue);

          return (
            <div
              style={{
                backgroundColor,
                padding: '4px 8px',
                borderRadius: '12px',
                display: 'inline-block',
                minWidth: '80px',
                textAlign: 'center',
                lineHeight: '18px',
                color,
              }}
            >
              {/* ✅ Ensure children is a string */}
              <Typography variant="body2" fontWeight={500}>
                {displayText}
              </Typography>
            </div>
          );
        },
      },
      {
        accessorKey: 'powerTamperingStatus',
        header: 'Power Tampering Status',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 200,
        Cell: ({ cell }) => {
          const status = cell.getValue();
          let backgroundColor;
          let color = '#219653';
          switch (status) {
            case 1:
              backgroundColor = '#FF0000';
              color = '#fff';
              break;
            case 0:
              backgroundColor = '#D9EDE6';
              break;
            default:
              backgroundColor = '#E0ECFD';
          }

          return (
            <div
              style={{
                backgroundColor: backgroundColor,
                padding: '4px 8px',
                borderRadius: '12px',
                display: 'inline-block',
                minWidth: '80px',
                textAlign: 'center',
                lineHeight: '18px',
                color: color,
              }}
            >
              <Typography variant="body2" fontWeight={500}>
                {status === 0 ? 'Connected' : 'Disconnected'}
              </Typography>
            </div>
          );
        },
      },
      {
        accessorKey: 'createdAt',
        header: 'Installed Date',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography
            variant="body2"
            fontWeight={400}
            sx={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
            }}
          >
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'expirationDate',
        header: 'Expiration Date',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ cell }) => (
          <Typography
            variant="body2"
            fontWeight={400}
            sx={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
            }}
          >
            {cell.getValue<string>()}
          </Typography>
        ),
      },

      {
        accessorKey: 'actions',
        header: 'Actions',
        muiTableBodyCellProps: {
          sx: {
            padding: '12px 16px',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        Cell: ({ row }) => (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <IconButton
              sx={{
                padding: 1,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
              onClick={(event) => {
                event.stopPropagation();
                console.info('IconButton clicked', row.original);
                if (row.original) {
                  navigate('details', {
                    state: {
                      deviceData: row.original,
                      selectedCompany: selectedCompany,
                      selectedUser: selectedUser,
                      filters: filterData,
                    },
                  });
                  // navigate('details', { state: {deviceData} });
                } else {
                  console.error('Row data is undefined');
                }
              }}
            >
              <img src={eye} alt="custom action" width={24} height={24} />
            </IconButton>
            {user?.authorities === 'ROLE_SUPER_ADMIN' && (
              <IconButton
                sx={{
                  padding: 1,
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                  borderRadius: '2px',
                }}
                onClick={() => handleDeleteClick(row.original)}
              >
                <img src={deleteIcon} alt="custom action" />
              </IconButton>
            )}
          </Box>
        ),
      },
    ];
  }, [isSmallScreen, selectedCompany, selectedUser, filterData]);

  const handleOpenMenu = (event: React.MouseEvent<HTMLSpanElement>, device: any) => {
    console.info(device, 'device IconButton');

    setAnchorEl(event.currentTarget);
    setSelectedDevice(device);
  };

  const columns: MRT_ColumnDef<Device>[] = useMemo(() => {
    return allColumns.filter((column) => {
      const key = column.accessorKey as keyof ColumnObjType;
      return columnObj[key]?.status;
    });
  }, [allColumns, columnObj]);

  const dynamicTableOptions = isSmallScreen
    ? {}
    : {
        enableColumnPinning: true,
        state: {
          columnPinning: {
            left: ['deviceId', 'vehicleRegistrationNo', 'updatedTime'],
            right: ['actions'],
          },
        },
        muiTableProps: {
          sx: {
            overflow: 'scroll',
            '& .MuiTableCell-root[data-pinned="true"]': {
              '&::before': {
                backgroundColor: 'transparent !important',
              },
              '&::after': {
                backgroundColor: 'transparent !important',
              },
            },
            '& td[data-pinned="true"]': {
              '&::before': {
                backgroundColor: 'transparent !important',
              },
              '&::after': {
                backgroundColor: 'transparent !important',
              },
            },
            '& th[data-pinned="true"]': {
              backgroundColor: '#F6F6FD',
              '&::before': {
                backgroundColor: 'transparent !important',
              },
              '&::after': {
                backgroundColor: 'transparent !important',
              },
            },
            '& tbody tr:nth-of-type(odd) td[data-pinned="true"]': {
              backgroundColor: '#FFFFFF !important',
            },
            '& tbody tr:nth-of-type(even) td[data-pinned="true"]': {
              backgroundColor: '#F6F6FD !important',
            },
          },
        },
        muiTableContainerProps: {
          sx: {
            width: '100%',
            maxWidth: '100%',
            overflowX: 'auto',
            overflowY: 'visible',
            backgroundColor: 'transparent',
            '&::-webkit-scrollbar': {
              width: '0px',
              height: '0px',
            },
            '&::-webkit-scrollbar-track': {
              background: '#f1f1f1',
              borderRadius: '3px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#c1c1c1',
              borderRadius: '3px',
            },
          },
        },
      };

  // Table options
  const tableOptions: MRT_TableOptions<Device> = {
    columns,
    data: paginatedData,
    enablePagination: false,
    enableColumnFilters: false,
    enableSorting: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableFullScreenToggle: false,
    enableColumnResizing: false,
    enableToolbarInternalActions: false,
    layoutMode: 'semantic',
    muiTablePaperProps: {
      sx: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
      },
    },
    muiTableProps: {
      sx: {
        tableLayout: 'fixed',
        width: '100%',
        backgroundColor: 'transparent',
        '& .MuiTableRow-root': {
          height: '48px !important',
          minHeight: '48px !important',
          maxHeight: '48px !important',
        },
        '& .MuiTableCell-root': {
          height: '48px !important',
          minHeight: '48px !important',
          maxHeight: '48px !important',
          padding: '0px 12px !important',
          verticalAlign: 'middle !important',
          boxSizing: 'border-box !important',
          lineHeight: '1 !important',
        },
        '& .MuiTableHead-root .MuiTableRow-root': {
          height: '48px !important',
          minHeight: '48px !important',
          maxHeight: '48px !important',
          boxShadow: 'none !important',
        },
        '& .MuiTableHead-root .MuiTableCell-root': {
          height: '48px !important',
          minHeight: '48px !important',
          maxHeight: '48px !important',
        },
        '& .MuiTableBody-root .MuiTableRow-root': {
          height: '48px !important',
          minHeight: '48px !important',
          maxHeight: '48px !important',
        },
        '& .MuiTableBody-root .MuiTableCell-root': {
          height: '48px !important',
          minHeight: '48px !important',
          maxHeight: '48px !important',
        },
      },
    },
    muiTableContainerProps: {
      sx: {
        width: '100%',
        maxWidth: '100%',
        overflowX: 'auto',
        overflowY: 'visible',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        '&::-webkit-scrollbar': {
          width: '0px',
          height: '0px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#c1c1c1',
          borderRadius: '3px',
        },
      },
    },
    muiTableBodyProps: {
      sx: {
        padding: 0,
        margin: 0,
        backgroundColor: 'transparent',
      },
    },
    muiTableHeadProps: {
      sx: {
        backgroundColor: '#F6F6FD',
        border: '1px solid #F0EFF8',
        borderRadius: '8px',
        height: '48px',
      },
    },
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: 'transparent',
        border: 'none',
        borderRadius: '0px',
        fontWeight: 600,
        fontStyle: 'normal',
        fontSize: '14px',
        lineHeight: '21px',
        letterSpacing: '0%',
        color: '#1B1B1B',
        height: '48px !important',
        minHeight: '48px !important',
        maxHeight: '48px !important',
        padding: '0px 12px !important',
        verticalAlign: 'middle',
        '&:first-of-type': {
          borderRadius: '8px 0 0 8px',
        },
        '&:last-of-type': {
          borderRadius: '0 8px 8px 0',
        },
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        height: '48px !important',
        minHeight: '48px !important',
        maxHeight: '48px !important',
        '& .MuiTableCell-root': {
          height: '48px !important',
          minHeight: '48px !important',
          maxHeight: '48px !important',
          verticalAlign: 'middle',
          padding: '0px 12px !important',
        },
        backgroundColor: row.index % 2 === 0 ? '#F0EFF8' : 'transparent',
      },
    }),
    muiTableBodyCellProps: {
      sx: {
        height: '48px !important',
        minHeight: '48px !important',
        maxHeight: '48px !important',
        padding: '0px 12px !important',
        verticalAlign: 'middle',
        lineHeight: '1 !important',
        boxSizing: 'border-box !important',
        backgroundColor: 'transparent',
      },
    },
    ...dynamicTableOptions,
  };

  const table = useMaterialReactTable(tableOptions);

  return (
    <>
      <AlertToast
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
      <div className="flex flex-col gap-4 w-full">
        {/* Search Input */}
        <div className=" w-full flex justify-between gap-4 xs:flex-col ">
          <div className="flex gap-2">
            <div className="max-w-[400px]">
              <TextField
                variant="outlined"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search"
                sx={(theme) => ({
                  '& .MuiOutlinedInput-root': {
                    borderColor: theme.palette.action.selected,
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%', // Ensure it takes full available height
                  },
                  '& .MuiInputBase-root': {
                    padding: '0rem 1rem',
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '0px 12px', // Adjust padding for better spacing
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                  },
                  width: {
                    xs: '100%', // full width on extra small screens
                    sm: '300px', // 300px on small screens
                    md: '400px', // 400px on medium and up
                  },
                })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={searchIcon} alt="icon" width={16} height={16} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={(theme) => ({
                        height: '48px', // Ensure full height
                        maxHeight: '48px',
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        borderLeft: `1px solid ${theme.palette.action.selected}`,
                        paddingLeft: '8px',
                      })}
                    >
                      <img src={filterIcon} onClick={handleFilterOpen} alt="icon" width={24} height={24} />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '14px', // You can adjust this as per Typography variant
                    fontWeight: 500, // Normal text weight
                  },
                }}
              />
            </div>
            {filterData && (
              <CustomIconButton
                text={`Clear Filters (${Object.values(filterData).filter((value) => value !== null).length})`}
                background="transparent"
                outline={false} // Set to true if you want an outline
                textColor="#C83333"
                onClick={() =>
                  handleFilterSave({
                    group: null,
                    device: null,
                    vehicle: null,
                  })
                }
              />
            )}
          </div>
          <div className="flex gap-4 flex-wrap">
            <CustomIconButton
              icon={<img src={Custom} alt="Custom" width={16} height={16} />}
              text="Customize"
              background="transparent"
              outline={false} // Set to true if you want an outline
              onClick={handleOpen}
            />
            <CustomIconButton
              icon={<img src={bulkUpload} alt="Upload" width={24} height={24} />}
              text="Bulk Upload"
              background="transparent"
              variant="outlined"
              onClick={() => setIsUploadModelOpen(true)}
            />
            <CustomIconButton
              icon={
                <img
                  src={download}
                  alt="download"
                  width={16}
                  height={16}
                  style={filteredData.length === 0 ? { filter: 'grayscale(1)', opacity: 0.5 } : undefined}
                />
              }
              text="Download"
              background="transparent"
              variant="outlined"
              isDisabled={filteredData.length === 0}
              onClick={() => setIsDownloadModalOpen(true)}
            />
            <CustomIconButton
              icon={<img src={PlusWhiteStroke} alt="Add" width={20} height={20} />}
              text="Add Device"
              variant="contained"
              onClick={() => navigate('add')}
              isDisabled={(!selectedUser || selectedUser === null) && isSuperAdmin}
            />
          </div>
        </div>
        <Box className="flex items-center w-full justify-between">
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            sx={{
              borderRadius: '8px',
              padding: '4px',
              backgroundColor: theme.palette.selected,
            }}
            TabIndicatorProps={{ style: { display: 'none' } }}
          >
            <Tab
              label="All Devices"
              sx={{
                ...(activeTab === 0
                  ? {
                      backgroundColor: theme.palette.background.default,
                      color: '#1B1B1B !important',
                      borderRadius: '8px',
                      fontWeight: 600,
                      padding: '8px 16px',
                      boxShadow: '0px 4px 6px #5547DD1A',
                    }
                  : { fontWeight: 400, color: '#1B1B1B !important' }),
              }}
            />
            <Tab
              label="Faulty Devices"
              sx={{
                ...(activeTab === 1
                  ? {
                      backgroundColor: theme.palette.background.default,
                      color: '#1B1B1B !important',
                      // color: theme.palette.primary.main,
                      borderRadius: '8px',
                      fontWeight: 600,
                      padding: '8px 16px',
                      boxShadow: '0px 4px 6px #5547DD1A',
                    }
                  : { fontWeight: 400, color: '#1B1B1B !important' }),
              }}
            />
          </Tabs>
        </Box>
        {!(isSuperAdmin ? deviceSuperAdminLoading : deviceLoading) &&
        !(activeTab === 1 && allDeviceLoading) ? (
          <>
            <MaterialReactTable table={table} />
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
              {viewMenuData.map((item, index) => {
                const isDisabled = item.disabled;
                return (
                  <MenuItem
                    key={index}
                    onClick={isDisabled ? undefined : item.click}
                    disabled={isDisabled}
                    sx={{
                      opacity: isDisabled ? 0.7 : 1,
                      cursor: isDisabled ? 'not-allowed' : 'pointer',
                      '&:hover': {
                        backgroundColor: isDisabled ? 'transparent' : 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <div className="flex gap-2 mt-1">
                      <img
                        src={item.icon}
                        alt={item.name}
                        style={{
                          marginRight: 8,
                          width: 20,
                          height: 20,
                        }}
                      />
                      <Typography variant="body2" fontWeight={600}>
                        {item.name}
                      </Typography>
                    </div>
                  </MenuItem>
                );
              })}
            </Menu>
          </>
        ) : (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              padding: 2,
            }}
          >
            {Array(5)
              .fill(null)
              .map((_, index) => (
                <Box key={index} sx={{ display: 'flex', gap: 1 }}>
                  {Array(6)
                    .fill(null)
                    .map((_, colIndex) => (
                      <Skeleton
                        key={colIndex}
                        variant="text"
                        width={`${100 / 6}%`}
                        height={48}
                        animation="wave"
                        sx={{
                          bgcolor: 'rgba(85, 71, 221, 0.08)',
                          '&::after': {
                            animationDuration: '1s',
                          },
                        }}
                      />
                    ))}
                </Box>
              ))}
          </Box>
        )}
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={
              activeTab === 1
                ? Math.ceil(filteredData.length / pageSize) || 1
                : relevantDeviceData?.data?.lastEvaluatedKey
                ? currentPage + 1
                : currentPage
            }
            page={currentPage}
            onChange={handlePageChange}
            shape="rounded"
            color="primary"
            siblingCount={0}
            boundaryCount={0}
            renderItem={(item) => {
              if (activeTab === 1) {
                // For faulty devices, show all pages that exist
                return <PaginationItem {...item} />;
              } else {
                // For all devices, limit to current + 1 page
                if (item.type === 'page' && item.page !== null && item.page > currentPage + 1) {
                  return null;
                }
                return <PaginationItem {...item} />;
              }
            }}
          />
        </Box>
      </div>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={isDeleteModalOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="delete-dialog-title">Delete Device</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description" sx={{ mb: 2 }}>
            Are you sure you want to delete this device <strong>{deleteingDevice?.deviceId}</strong>?
          </DialogContentText>
          <InputField
            multiline
            rows={3}
            label="Reason to Delete"
            placeholder="Enter reason for deletion (minimum 50 characters)"
            value={deleteReason}
            onChange={(e) => setDeleteReason(e.target.value)}
            isMandatory
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary" disabled={deviceDeleteLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            color="error"
            autoFocus
            disabled={deleteReason.length < 50 || deviceDeleteLoading}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <DownloadData
        downloadLoading={isSuperAdmin ? downloadDeviceSuperAdminLoading : downloadDeviceLoading}
        isDownloadModalOpen={isDownloadModalOpen}
        handleDownloadModalClose={handleDownloadModalClose}
        selectedFormat={selectedFormat}
        handleFormatChange={handleFormatChange}
        handleDownload={handleDownload}
        modalTitle="Download Device Data"
        modalDescription="Please select a file format for your download."
        formatLabel="Format"
        formatExcelLabel="Excel"
        formatCsvLabel="CSV"
        formatPdfLabel="PDF"
        cancelButtonText="Cancel"
        downloadButtonText="Download"
      />

      <CustomiseTableModal
        open={isCustomiseModalOpen}
        onClose={() => setIsCustomiseModalOpen(false)}
        title="Customize Your Table"
        description="Choose which sections to display and arrange them the way you like."
        columnObj={columnObj}
        setColumnObj={setColumnObj}
        onReset={handleReset}
        // initialColumnObj={initialColumnObj}
        tilesObj={tilesObj}
        setTilesObj={setTilesObj}
      />
      {isUploadModelOpen && (
        <BulkUploadModal
          open={isUploadModelOpen}
          handleClose={handleUploadModalClose}
          uploadEndpoint={API_ENDPOINTS.directories.DEVICE_BULK_UPLOAD}
          title="Bulk upload"
          description="Upload an Excel/CSV files to add multiple devices at once."
          entityType="devices"
          sampleFileUrl={API_ENDPOINTS.directories.DEVICE_SAMPLE_DOWNLOAD}
        />
      )}

      <FilterDeviceModal
        open={isFilterModel}
        onClose={handleFilterClose}
        handleFilterSave={handleFilterSave}
        title={`Filters (${relevantDeviceData?.data?.length || 0} Devices)`}
        description="Use the options below to refine your search and find specific device quickly."
        selectedUser={selectedUser}
        filterData={filterData}
      />
    </>
  );
};

export default DeviceDataTable;
